import { render, staticRenderFns } from "./STEMNetwork2024.vue?vue&type=template&id=7af1350d&scoped=true"
import script from "./STEMNetwork2024.vue?vue&type=script&lang=js"
export * from "./STEMNetwork2024.vue?vue&type=script&lang=js"
import style0 from "./STEMNetwork2024.vue?vue&type=style&index=0&id=7af1350d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af1350d",
  null
  
)

export default component.exports